// extracted by mini-css-extract-plugin
module.exports = {"tooltip-text":"styles_tooltip-text__Ys__r"};